import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Map, BookOpen, Trophy, User } from "lucide-react";

const ITEMS = [
  { path: "/hub", label: "Home", icon: Home, testid: "nav-home" },
  { path: "/map", label: "Play", icon: Map, testid: "nav-map" },
  { path: "/learn", label: "Learn", icon: BookOpen, testid: "nav-learn" },
  { path: "/rewards", label: "Rewards", icon: Trophy, testid: "nav-rewards" },
  { path: "/profile", label: "Me", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 glass-dark border-t border-white/10"
         data-testid="bottom-nav">
      <div className="max-w-4xl mx-auto flex items-stretch justify-around px-2 py-2">
        {ITEMS.map((it) => {
          const active = pathname.startsWith(it.path);
          const Icon = it.icon;
          return (
            <button
              key={it.path}
              data-testid={it.testid}
              onClick={() => navigate(it.path)}
              className="flex flex-col items-center gap-1 px-3 py-1 rounded-2xl press"
              style={active ? { background: "rgba(255,42,122,0.16)" } : {}}>
              <Icon size={22} className={active ? "text-[#FF2A7A]" : "text-[#A8B2D1]"} />
              <span className={`text-[11px] font-semibold ${active ? "text-white" : "text-[#A8B2D1]"}`}>
                {it.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
